import React from "react";
import { AlertCircle, X, Save } from "lucide-react";
import { Loader } from "@/components/ui/loader";
import { Button } from "@/components/ui/button";

interface Props {
  isLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const EditToolbar: React.FC<Props> = ({ isLoading, onSave, onCancel }) => (
  <div className="flex items-center justify-between rounded-md border border-coral/20 bg-coral/10 px-3 py-2">
    <div className="flex items-center gap-2 text-xs text-coral">
      <AlertCircle className="h-3.5 w-3.5" />
      <span className="font-medium">Editing section content</span>
    </div>
    <div className="flex gap-1.5">
      <Button size="xs" variant="ghost" onClick={onCancel} className="h-7 text-coral hover:bg-coral/20">
        <X className="mr-1.5 h-3.5 w-3.5" />
        Cancel
      </Button>
      <Button size="xs" onClick={onSave} disabled={isLoading} className="h-7 bg-coral text-white hover:bg-coral/90">
        {isLoading ? (
          <>
            <Loader className="mr-1.5 h-3.5 w-3.5" />
            Saving...
          </>
        ) : (
          <>
            <Save className="mr-1.5 h-3.5 w-3.5" />
            Save
          </>
        )}
      </Button>
    </div>
  </div>
);
